import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/device/page/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/park/device/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/park/device/remove/v2', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/park/device/save/v2', params, options);

export const update = (params, options) => request.post('/api/park/device/update/v2', params, options);

export const stop = (params, options) => request.post('/api/park/device/stop/v2', qs.stringify(params), options);

export const start = (params, options) => request.post('/api/park/device/start/v2', qs.stringify(params), options);

export const retry = (params, options) => request.post('/api/park/device/retry/v2', qs.stringify(params), options);


//单独升级
export const upgrade = (row) => {

  return request({
    url: '/api/park/device/upgrade',
    method: 'post',
    data: row,
  });
};


export const getFirmwareList = (params, options) =>
  request.get('/api/v4ward/park/firmware/getList', Object.assign({}, options, {
    params
  }));
